import ProgressBar from 'components/shared/ProgressBar/ProgressBar';

const WizardProgressBar = ({ value }) => {
  if (value === null || value === undefined || value === '') return null;
  const getProgressColor = () => {
    const pct = Math.max(0, Math.min(100, Number(value) || 0));
    if (pct < 30) return 'bg-danger-500';
    if (pct < 70) return 'bg-warning-500';
    if (pct == 100) return 'bg-success-500';
    return 'bg-primary-500';
  };
  return (
    <div className="flex h-full w-full items-center justify-between gap-4">
      <div className="w-full max-w-[60%]">
        <ProgressBar
          progress={Math.max(0, Math.min(100, Number(value) || 0))}
          className="!h-1.5"
          progressColor={getProgressColor()}
        />
      </div>
      <span className="text-right text-sm font-medium">
        {Math.max(0, Math.min(100, Number(value) || 0)).toFixed(0)}%
      </span>
    </div>
  );
};

export default WizardProgressBar;
